
import styled from "styled-components";

export const AvisoPrivacidadeBody = styled.div`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  line-height: 1.6;
   margin-top: 110px;
`;

export const Hr = styled.hr`
    width: 90px;
    height: 3px;
    background: #ff8456;
    right: 150px;
    margin-top: 0px;
    border: none;
`;
export const PrivacySection = styled.section`
  margin-bottom: 2.5rem;
  padding: 1.5rem;
  scroll-margin-top: 110px;
  border-radius: 8px;
  background-color: rgb(247,249,255);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  position: sticky;
  top: 110px;
  z-index: 1020;
  h2 {
    color: var(--primary-color);
    border-bottom: 2px solid var(--accent-color);
    padding-bottom: 0.5rem;
    margin-bottom: 1.5rem;
  }

  h3 {
    color: var(--secondary-color);
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
`;

export const PrivacySectionContent = styled.section`
     margin-bottom: 2.5rem;
  padding: 1.5rem;
  scroll-margin-top: 110px;
  border-radius: 8px;
  background-color:rgb(247,249,255);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

export const Title = styled.div`
    text-align: center;
    position: fixed-top;
    color: #1f2183;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    p {
        font-size: 20px;
    }
`;

export const TocLink = styled.a`
  color: #333;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    color: var(--primary-color);
    text-decoration: underline;
  }
`;

export const TocSticky = styled.div`
  position: sticky;
        top: 110px;
        z-index: 1020;  
        @media (max-width: 991.98px) {
            position: static;
        }
`;